import { makeStyles } from '@mui/styles'
import {
  FinanceCalculatorTheme,
  FcFinanceBreakdownElementClasses,
} from '@dxp-module/themes'

const financeBreakdownElementStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcFinanceBreakdownElementClasses
>(
  () => ({
    breakdownElementContainer: {
      display: 'block',
      justifyContent: 'unset',
    },
    textSuffix: {},
  }),
  { name: 'FC_FinanceBreakdownElement' }
)

export default financeBreakdownElementStyles
